import styled from "styled-components"
import React from "react"
import Modal, { BaseModalBackground } from "styled-react-modal"
// import reflection_background from 'src/assets/background_with_cross.svg'
import { mediaURL } from "src/consumer/services"

export const StyledJournalModal = Modal.styled`
  width: 360px;
  height: 550px;
  opacity: ${(props) => props.opacity};
  transition : all 0.3s ease-in-out;
  border-radius: 15px;
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme?.themeC5};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) and (min-height: 800px) {
    width: 691px;
    height: 652px;
    border-radius: 25px;
  }
`

export const FadingBackground = styled(BaseModalBackground)`
  opacity: ${(props) => props.opacity};
  transition: all 0.3s ease-in-out;
  z-index: 1000;
`

export const CongratulationHeading = styled.div`
  font-family: Outfit;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  color:  ${({ theme }) => theme?.themeC1};
  @media (min-width: 768px) and (min-height: 800px) {
    font-size: 42px;
  }
`

export const CongratulationText = styled.div`
  font-family: Outfit;
  font-size: ${props => props?.textTwo ? '16px' : '21px'};
  font-weight: ${props => props?.textTwo ? '500' : '600'};
  text-align: center;
  color: ${props => props?.textTwo ? `${({ theme }) => theme?.themeC2}` : `${({ theme }) => theme?.themeC1}`};
  margin-top: ${props => props?.textTwo ? '5px' : '5px'};
  @media (min-width: 768px) and (min-height: 800px) {
    font-size: ${props => props?.textTwo ? '21px' : '24px'};
  }
`

export const DiamondContainer = styled.div`
  height: 75px;
  width: 200px;
  margin-top: 8px;
  border-radius: 50px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  background:  ${({ theme }) => theme?.themeC1};
  font-family: Outfit;
  font-size: 42px;
  font-weight: 700;
  line-height: 53px;
  text-align: center;
  color: #FFF;
  @media (max-height: 880px) {
    height: 50px;
    width: 150px;
    font-size: 32px;
    font-weight: 500;
    line-height: 45px;
  }
`

export const CompletedItemContainer = styled.div`
  padding: 20px 10px;
  width: 90%;
  max-width: 435px;
  border-radius: 20px;
  background:  ${({ theme }) => theme?.themeC2};
  margin: 17px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  @media (min-width: 768px) and (min-height: 800px) {
    gap: 40px;
  }
`

export const CompletedItemImage = styled.img`
  height: 86px;
  width: 86px;
  border-radius: 12px;
  object-fit: cover;
  object-position: right;
  @media (min-width: 768px) and (min-height: 800px) {
    height: 106px;
    width: 106px;
  }
`

export const CompletedItemTitle = styled.div`
  font-family: Outfit;
  font-size: ${props => props?.sub ? '15px' : '25px'};
  font-weight: ${props => props?.sub ? '300' : '600'};
  line-height: ${props => props?.sub ? '19px' : '32px'};
  letter-spacing: 0em;
  text-align: left;
  color: #FFF;
  @media (max-height: 880px) {
    font-size: ${props => props?.sub ? '12px' : '20px'};
    font-weight: ${props => props?.sub ? '300' : '600'};
    line-height: ${props => props?.sub ? '16px' : '27px'};
  }
`

export const CompletedItem = (props) => {

  const { completedItemType, itemData } = props;

  let img;
  let imgURL;
  let title;
  let subtitle;

  if (completedItemType === "journal") {
    img = itemData?.coverIcon || itemData?.coverImage
    imgURL = `${mediaURL}${img}`;
    title = itemData?.title;
    subtitle = itemData?.journalQusAns?.length + ' questions'
  } else if (completedItemType === "reflection") {
    // imgURL = reflection_background
    title = itemData?.title;
    subtitle = "2 mins";
  } else if (completedItemType === "course") {
    img = itemData?.selectedCard?.course?.sessions?.[0]?.coverIcon || itemData?.selectedCard?.course?.sessions?.[0]?.coverIcon;
    imgURL = `${mediaURL}${img}`;
    title = itemData?.selectedCard?.course?.sessions?.[0]?.title;
    subtitle = itemData?.selectedCard?.course?.sessions?.[0]?.duration / 60000 + ' mins'
  }

  return (
    <CompletedItemContainer>
      <CompletedItemImage src={imgURL} />
      <div className="flex flex-col">
        <CompletedItemTitle>{title}</CompletedItemTitle>
        <CompletedItemTitle sub>{subtitle}</CompletedItemTitle>
      </div>
    </CompletedItemContainer>
  )
}

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 17.3px;
  border-radius: 17px;
  background: ${({ theme }) => theme?.themeC3};
  @media (min-width: 768px) and (min-height: 800px) {
    height: 21.3px;
  }
`

export const ProgressBarFilled = styled.div`
  background-color: #434e64;
  text-align: right;
  position: relative;
  background: #824ABD;
`

export const LevelProgressBar = styled.div`
  width: 50%;
  position: relative;
  margin-top: 40px;
`

export const GemImage = styled.img`
  width: 66px;
  height: 54px;
  position: absolute;
  left: ${props => `calc(${props.progress}% - 33px)`};
  top: -15px;
  z-index: 2;
`

export const TotalScoreNow = styled.div`
  height: 37.49px;
  width: 100px;
  border-radius: 50px;
  background: ${({ theme }) => theme?.themeC3};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Outfit;
  font-size: 19px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: #FFF;
  position: absolute;
  left: ${props => `calc(${props.progress}% - 50px)`};
  top: 37px;
`

export const ScoredNow = styled.div`
  font-family: Outfit;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  color:  ${({ theme }) => theme?.themeC3};
  position: absolute;
  left: ${props => `calc(${props.progress}% - 15px)`};
  top: -45px;
`

export const CoinsNeededText = styled.div`
  font-family: Outfit;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: right;
  color:  ${({ theme }) => theme?.themeC3};
  position: absolute;
  right: 0;
  top: 75px;
`

export const CloseButton = styled.div`
  font-family: Outfit;
  text-align: center;
  color: #FFF;
  background:  ${({ theme }) => theme?.themeC1};
  opacity: ${props => props?.show ? '1' : '0'};
  transition: all 0.5s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 20px;
  font-weight: 600;
  margin: 100px 0 0 0;
  padding: 8px 20px;
  border-radius: 30px;
  @media (min-weight: 880px) and (min-height: 800px) {
    padding: 12px 25px;
    font-size: 30px;
    font-weight: 600;
  }
`